import { appConfig } from "@/config/app";

/** Nom de la marque pour les textes du site (jamais écrit en dur). */
export const BRAND = appConfig.name;
